import { render, staticRenderFns } from "./RobertLepage.vue?vue&type=template&id=2dd95f06"
import script from "./RobertLepage.vue?vue&type=script&lang=js"
export * from "./RobertLepage.vue?vue&type=script&lang=js"
import style0 from "./RobertLepage.vue?vue&type=style&index=0&id=2dd95f06&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports